import { LogLevel } from "@azure/msal-browser";

class MicrosoftService {

  config = () => {
    return {
      auth: {
          // meridian
          // clientId: "e2b2596c-f2aa-4d31-896f-fe90be68b06c",
          // authority: "https://login.microsoftonline.com/meridianenergy.onmicrosoft.com",
          // redirectUri: "/",
          // postLogoutRedirectUri: "/",
          // navigateToLoginRequestUrl: false,

          // // youdo
          // clientId: "api://7563d07d-6dcb-48c5-9ed8-c8a7bf5066e4",
          // authority: "https://login.microsoftonline.com/665a3fd9-4577-4bd5-bbb7-b968aff9d1b7",
          // redirectUri: "/",
          // postLogoutRedirectUri: "/",
          // navigateToLoginRequestUrl: false,

          clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
          authority: process.env.REACT_APP_MSAL_TENANT_ID,
          redirectUri: "/blank.html",
          postLogoutRedirectUri: "/",
          navigateToLoginRequestUrl: false,
      },

      cache: {
          cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
          storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
      },
      system: {
          loggerOptions: {
              loggerCallback: (level, message, containsPii) => {
                  if (containsPii) {
                      return;
                  }
                  switch (level) {
                      case LogLevel.Error:
                          console.error(message);
                          return;
                      case LogLevel.Info:
                          console.info(message);
                          return;
                      case LogLevel.Verbose:
                          console.debug(message);
                          return;
                      case LogLevel.Warning:
                          console.warn(message);
                          return;
                      default:
                          console.warn(message);
                          return
                  }
              }
          }
      }
    }
  }

  login = () => {
    return {
      scopes: [process.env.REACT_APP_MSAL_SCOPE]
    }
  }
}

const MicrosoftServiceInstance = new MicrosoftService()
export { MicrosoftServiceInstance as MicrosoftService }
